import { CATEGORIES } from '../data/questions';
import type { MatchResult, MatchItem } from '../types';
import { formatCounterpartPrompt } from './resultsDisplay';

const INTENSITY_EMOJI: Record<string, string> = {
  open: '🤔',
  like: '🥰',
  love: '🔥',
};

const INTENSITY_LABEL: Record<string, string> = {
  open: 'Curious',
  like: 'Yes please',
  love: 'Hell yes!',
};

function formatMatch(match: MatchItem, partnerAName: string, partnerBName: string): string {
  const answerLine = `${partnerAName}: ${INTENSITY_EMOJI[match.intensityA]} ${INTENSITY_LABEL[match.intensityA]} · ${partnerBName}: ${INTENSITY_EMOJI[match.intensityB]} ${INTENSITY_LABEL[match.intensityB]}`;

  if (match.matchType === 'counterpart' && match.counterpartQuestionText) {
    return [
      formatCounterpartPrompt(
        match.questionText,
        match.counterpartQuestionText,
        partnerAName,
        partnerBName,
      ),
      answerLine,
    ].join('\n');
  }

  return `${match.questionText}\n${answerLine}`;
}

export function formatResultsAsText(data: MatchResult, resultsUrl: string): string {
  const lines: string[] = [];

  // Header
  lines.push(`🔥 OurSexQuiz Results`);
  lines.push(`${data.partnerAName} & ${data.partnerBName} — ${data.totalMatches} matches`);

  // Unlock link (only if unpaid with premium matches)
  if (!data.isPaid && data.premiumMatchCount > 0) {
    lines.push('');
    lines.push('See your full results:');
    lines.push(resultsUrl);
  }

  // Categories in quiz order
  for (const cat of CATEGORIES) {
    const catData = data.categories[cat.id];
    if (!catData) continue;

    const visibleMatches = catData.matches;
    if (visibleMatches.length === 0 && catData.totalMatches === 0) continue;

    lines.push('');
    lines.push(`${cat.emoji} ${cat.label} (${catData.totalMatches} ${catData.totalMatches === 1 ? 'match' : 'matches'})`);

    for (const match of visibleMatches) {
      lines.push('');
      lines.push(formatMatch(match, data.partnerAName, data.partnerBName));
    }

    // Per-category locked count
    const lockedCount = catData.totalMatches - visibleMatches.length;
    if (lockedCount > 0) {
      lines.push('');
      lines.push(`🔑 ${lockedCount} more ${lockedCount === 1 ? 'match' : 'matches'} to discover`);
    }
  }

  // Footer
  lines.push('');
  lines.push('Discover your matches at oursexquiz.com');

  return lines.join('\n');
}
